import UserNotificationSettings from './UserNotificationSettings'

export default UserNotificationSettings
